//Funciones que se comunican con la API De forma directa, son usadas por los componentes 

import axios from 'axios';

//const API_URL = window.ENV.API_URL+'';
const API_URL = window.ENV.API_URL+'';

//Crear un formulario remoto
export async function createForm(nombres, paterno, materno, rut, pais, ciudad, direccion, telefono, genero, nacimiento, email, foto, estado_civil) {
    //AGREGAR ESTADO CIVIL
    const params = {
        "NOMBRES": nombres,
        "PATERNO": paterno,
        "MATERNO": materno,
        "RUT_PASAPORTE": rut,
        "ID_PAIS": pais,
        "ID_CIUDAD": ciudad,
        "DIRECCION": direccion,
        "TELEFONO": telefono,
        "GENERO": genero,
        "FECHA_NACIMIENTO": nacimiento,
        "EMAIL": email,
        "ID_ESTADO_CIVIL": estado_civil
    };
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    const res = await axios.post(`${API_URL}/formulario-visita/`, params, headers);
    if(foto){
        const file = await getFromFile(foto)
        const file2 = await resizedataURL(file)
        const params_foto = {
            "EMAIL": email,
            "FOTO": file2
        };
        await axios.post(`${API_URL}/ingresar_imagen/`, params_foto, headers);
    }
    return res;
};

const getFromFile = (file) => {
  const tmpFR = new FileReader();

  return new Promise((resolve, reject) => {
    tmpFR.onerror = () => {
      tmpFR.abort();
      reject(new DOMException("Houston, we have a problem parsing file."));
    };

    tmpFR.onload = () => { resolve(tmpFR.result); };
    tmpFR.readAsDataURL(file);
  });
};

function getMeta(file){
    return new Promise (function (resolved, rejected) {
        var i = new Image()
        i.onload = function(){
        resolved({w: i.width, h: i.height})
        };
        i.src = file
    }) 
}

// Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
export async function resizedataURL(datas){
    return new Promise(async function(resolve,reject){
        let dimensions_img = await getMeta(datas)

        let wantedWidth = dimensions_img.w;
        let wantedHeight = dimensions_img.h;

        if (wantedWidth == wantedHeight) {
            if (wantedWidth > 240) {
                wantedHeight = 240;
                wantedWidth = 240;
            }
        } else if(wantedWidth > wantedHeight) {
            if (wantedWidth > 240) {
                wantedHeight *= 240 / wantedWidth;
                wantedWidth = 240;
            }
        }else {
            if (wantedHeight > 320) {
                wantedWidth *= 320 / wantedHeight;
                wantedHeight = 320;
            }
        }

        // We create an image to receive the Data URI
        var img = document.createElement('img');

        // When the event "onload" is triggered we can resize the image.
        img.onload = function()
        {        
            // We create a canvas and get its context.
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            // We set the dimensions at the wanted size.
            canvas.width = wantedWidth;
            canvas.height = wantedHeight;

            // We resize the image with the canvas method drawImage();
            ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

            var image_quality = 0.9;
            var dataURI = canvas.toDataURL("image/jpeg",image_quality);

            var stringLength = dataURI.length - 'data:image/png;base64,'.length;
            var sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
            var sizeInKb=sizeInBytes/1024;

            while(sizeInKb > 60){
                image_quality = image_quality - 0.05;
                dataURI = canvas.toDataURL("image/jpeg",image_quality);
                
                stringLength = dataURI.length - 'data:image/png;base64,'.length;
                sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
                sizeInKb=sizeInBytes/1024;
            }

            // This is the return of the Promise
            resolve(dataURI);
        };

        // We put the Data URI in the image's src attribute
        img.src = datas;

    })
}
//Crear una nueva visita 
export async function createVisit(id_solicitud, id_formulario, id_enlace, id_solicitud_prorroga, id_estado_carga_tui, id_estado_solicitud) {
    const params = {
        "ID_SOLICITUD": id_solicitud,
        "ID_FORMULARIO": id_formulario,
        "ID_ENLACE": id_enlace,
        "ID_SOLICITUD_PRORROGA": id_solicitud_prorroga,
        "ID_ESTADO_CARGA_TUI": id_estado_carga_tui,
        "ID_ESTADO_SOLICITUD": id_estado_solicitud,
    };

    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    let res = await axios.post(`${API_URL}/visita/`, params, headers);

    console.log('RESPUESTA: ',res);

    let url_link = '';

    if(res.data.ID_ENLACE !== null){
        url_link = res.data.ID_ENLACE.ENLACE_URL;
    }
    
    const params_notificar = {
        "NOMBRES": res.data.ID_FORMULARIO.NOMBRES,
        "PATERNO": res.data.ID_FORMULARIO.PATERNO,
        "MATERNO": res.data.ID_FORMULARIO.MATERNO,
        "GENERO": res.data.ID_FORMULARIO.GENERO,
        "EMAIL": res.data.ID_FORMULARIO.EMAIL,
        "ENLACE_URL": url_link
    };

    let caso_solicitud = res.data.ID_ESTADO_SOLICITUD.ID_ESTADO_SOLICITUD;

    if(caso_solicitud == "1"){
        await axios.post(`${API_URL}/notificar_aprobacion/`, params_notificar, headers);
    }else if(caso_solicitud == "3"){
        await axios.post(`${API_URL}/notificar_aprobacion_enlace/`, params_notificar, headers);
    }

    return res;
};

//Crear una solicitud de Visita 
function createSol(id_funcionario, tipo, id_sponsor, inicio, termino, unidad, presencial) {
    const params = {
        "ID_ORGANISMO": unidad,
        "FECHA_INICIO": inicio,
        "FECHA_TERMINO": termino,
        "ID_TIPO_VISITA": tipo,
        "ID_FUNCIONARIO": id_funcionario,
        "ID_PATROCINADOR": id_sponsor,
        "ES_PRESENCIAL": presencial,
    };
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.post(`${API_URL}/solicitud/`, params, headers);
};

// Actualizar la información de una visita 
function updateSol(id, comentario, id_funcionario, tipo, estado, id_visita, id_sponsor, inicio, termino, facultad, unidad) {

    const params = {
        "comentario": comentario,
        "id_funcionario": id_funcionario,
        "id_visita": id_visita,
        "id_tipo_visita": tipo,
        "id_estado": estado,
        "id_patrocinador": id_sponsor,
        "fecha_inicio": inicio,
        "fecha_termino": termino,
        "id_facultad": facultad,
        "id_unidad": unidad,
    };
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.put(`${API_URL}/solicitud-visita/${id}/`, params, headers);
};

function updateVisita(id_visita,id_estado_solicitud){
    const params = {
        "ID_ESTADO_SOLICITUD": id_estado_solicitud,
    };
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    console.log(params)

    return axios.put(`${API_URL}/visita/${id_visita}/`, params, headers);
};

function updateVisitaProrroga(id_visita,id_solicitud_prorroga,id_estado_solicitud){
    const params = {
        "ID_ESTADO_SOLICITUD": id_estado_solicitud,
        "ID_SOLICITUD_PRORROGA": id_solicitud_prorroga,
    };
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    return axios.put(`${API_URL}/visita/${id_visita}/`, params, headers);
};

export async function updateVisitaPersona(values) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    const params = {
        "id_visita": values.id_visita,
        "rut_pasaporte": values.rut_pasaporte,
        "comentario": values.comentario, 
        "estado": values.estado
    };

    const res = await axios.post(`${API_URL}/cambiar_estado_visita/`, params, headers);
    return res;
};

//Funcion para actualizar un pase visita
function updatePase(pase, vigencia, inicio, termino, facultad, unidad, sponsor) {
    const params = {
        "vigencia": vigencia,
        "fecha_inicio": inicio,
        "fecha_termino": termino,
        "id_facultad": facultad,
        "id_unidad": unidad,
        "id_patrocinador": sponsor,
    };

    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.put(`${API_URL}/pase-visita/${pase}/`, params, headers);
};

//Funcion para obtener ciudades 
export function getCiudades() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/ciudades`, headers);
}

//Funcion para obtener municipios 
export function getMunicipios() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/municipios`, headers);
}

//Funcion para obtener paises 
export function getPaises() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/paises`, headers);
}

//Funcion para obtener regiones
export function getRegiones() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
     return axios.get(`${API_URL}/regiones`, headers);
}

//Funcion para obtener Organismos de la universidad
export function getOrganismos() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
     return axios.get(`${API_URL}/organismos`, headers);
}

//Funcion para obtener Organismos de la universidad
export function getOrganismosRepart(codigo_reparticion) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };  

    return axios.get(`${API_URL}/organismos?codigo_reparticion=${codigo_reparticion}`, headers);
}

//Funcion para obtener las visitas que existen 
export function getVisit() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/visita/`, headers);
}

export function getApprovedVisit() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/visita/?ID_ESTADO_SOLICITUD=1`, headers);
}

export function datosProrroga(rutPasaporte) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    const params = {
        "rutPasaporte": rutPasaporte
    };
    return axios.post(`${API_URL}/datos_prorroga/`, params, headers);
}

export async function getApprovedVisitv2(rutPasaporte) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    let formulario = await axios.get(`${API_URL}/formulario-visita/?RUT_PASAPORTE=${rutPasaporte}`, headers);
    return axios.get(`${API_URL}/visita/?ID_ESTADO_SOLICITUD=1&ID_FORMULARIO=${formulario.data[0].ID_FORMULARIO_VISITA}`, headers);
}

export async function getNotApprovedVisit(id_organismo,permisos_usuario) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    const params = {
        "id_organismo": id_organismo,
        "permisos_usuario": permisos_usuario
    };

    let test_res = await axios.post(`${API_URL}/mis_solicitudes_listado/`, params, headers);

    return test_res.data;
}


//Funcion para obtener el formulario visita de un rut
export async function getFormVisitRut(rut){
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    let params = {
        "rut": rut
    }
    return await axios.post(`${API_URL}/rut_formulario_visita`, params, headers);

}

//Función para obtener los pase - visita creados 
export function getPases() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/pase-visita/`, headers);
}

// Funcion que entrega los estados civiles posibles 
export function get_estado_civil(){
    const headers = {
        headers: {
            Authorization: window.Token
        }
    }   
    return axios.get(`${API_URL}/estado_civil`, headers);
}

//Funcion para obtener los patrocinadores existentes 
export function getSponsors(data) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    const params = {
        'sponsors': data
    }
    return axios.post(`${API_URL}/patrocinador/`, params,headers);
}

export function getSponsorsParams(data) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    let queryParams
    if(data.checkRut === '0'){
        console.log("rut")
        queryParams = new URLSearchParams({
            id_organismo_padre: data.nivelTres,                      
          })        
        queryParams = "/"+data.rut_pasaporte + "?" + queryParams
    } else {
        console.log("nombre")
        queryParams = new URLSearchParams({
            id_organismo_padre: data.nivelTres,            
            nombre: data.nombres
          })        
          queryParams = "?" + queryParams
    }    
    return axios.get(`${API_URL}/patrocinador${queryParams}`, headers);
}

// Funcion para obtener los tipos de visita 
export function getTypesVisits() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/tipos_visita`, headers);
}

export function getEstadosCiviles() {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.get(`${API_URL}/estado_civil`, headers);
}

//Funcion que verifica con la api si un rut ya existe en las visitas 
export function checkrut(rut) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
        
    };
    const params = {
        "rut": rut
    };
    return axios.post(`${API_URL}/rut-verify`,params, headers);
}

//Funcion que verifica si el mail existe y obtiene el id_formulario
export function emailVerifierUrl(email){
    const headers = {
        headers: {
            Authorization: window.Token
        }
        
    };
    const params = {
        "email": email
    };
    return axios.post(`${API_URL}/email_verifier_url/`,params, headers);
}

//Reenviar mail
export function visitConsumerReenviarMail(mail) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
        
    };
    const params = {
        "mails": mail
    };
    return axios.post(`${API_URL}/reenviar_invitacion/`,params, headers);
}

//Función para crear una prorroga 
function createProrroga(id_funcionario, termino, causal, estado_carga_tui) {
    const params = {
        "ID_FUNCIONARIO": id_funcionario,
        "FECHA_TERMINO": termino,
        "CAUSAL": causal,
        "ID_ESTADO_CARGA_TUI": estado_carga_tui,
    };

    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    return axios.post(`${API_URL}/solicitud-prorroga/`, params, headers);
}

//Funcion para crear un formulario presencial 
export async function formularioPresencial(values){
    //AGREGAR ESTADO CIVIL
    let idPersona = await getIdFuncionario(window.User.Rut)
    var res1 = await createForm(
        values.nombres,
        values.paterno,
        values.materno,
        values.rut_pasaporte,
        values.address.country,
        values.address.city,
        values.address.street,
        values.phone,
        values.gender,
        values.birthday.format('YYYY-MM-DD'),
        values.user.email,
        values.photo,
        values.estado_civil
    ).then(res1 => {return res1});
    var res2 = await createSol(
        idPersona.data.id_persona,
        window.ENV.API_URL+"/tipos-visita/".concat(values.tipo, "/"),
        values.sponsor,
        values.dates[0].format('YYYY-MM-DD'),
        values.dates[1].format('YYYY-MM-DD'),
        values.unidad.departamento,
        1
    ).then(res2 => {return res2});
    var res3 = await createVisit(
        res2.data.url,
        res1.data.url,
        null,
        null,
        window.ENV.API_URL+"/estado-tui/0/",
        window.ENV.API_URL+"/estados-solicitud/1/"
    ).then(res3 => {return res3})
    return res3;
}

export async function formularioPresencialUpdate(values){
    //AGREGAR ESTADO CIVIL
    let idPersona = await getIdFuncionario(window.User.Rut)
    var res1 = await updateForm(values).then(res1 => {return res1});
    var res2 = await createSol(
        idPersona.data.id_persona,
        window.ENV.API_URL+"/tipos-visita/".concat(values.tipo, "/"),
        values.sponsor,
        values.dates[0].format('YYYY-MM-DD'),
        values.dates[1].format('YYYY-MM-DD'),
        values.unidad.departamento,
        1
    ).then(res2 => {return res2});
    var res3 = await createVisit(
        res2.data.url,
        res1.data.url,
        null,
        null,
        window.ENV.API_URL+"/estado-tui/0/",
        window.ENV.API_URL+"/estados-solicitud/1/"
    ).then(res3 => {return res3})
    return res3;
}

export async function updateRemoteForm (values, url) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    const response = await axios.get(`${API_URL}/enlace/?ENLACE_URL=${url}`, headers);
    const responseVisita = await axios.get(`${API_URL}/visita/?ID_ENLACE=${response.data[0].ID_ENLACE}`, headers);
    const id_formulario = responseVisita.data[0].ID_FORMULARIO.ID_FORMULARIO_VISITA;
    const datosVisita = responseVisita.data[0]
    if(values.photo){
        const file = await getFromFile(values.photo)
        const params_foto = {
            "EMAIL": responseVisita.data[0].ID_FORMULARIO.EMAIL,
            "FOTO": file,
        };
        await axios.post(`${API_URL}/ingresar_imagen/`, params_foto, headers);
    }
    const params = {
        "NOMBRES": values.nombres,
        "PATERNO": values.paterno,
        "MATERNO": values.materno,
        "RUT_PASAPORTE": values.rut_pasaporte,
        "ID_PAIS": values.address.country,
        "ID_CIUDAD": values.address.city,
        "DIRECCION": values.address.street,
        "TELEFONO": values.phone,
        "GENERO": values.gender,
        "FECHA_NACIMIENTO": values.birthday.format('YYYY-MM-DD'),
        "EMAIL": responseVisita.data[0].ID_FORMULARIO.EMAIL,
        "ID_ESTADO_CIVIL": values.estado_civil,
    };
    await updateVisita(datosVisita.ID_VISITA,window.ENV.API_URL+"/estados-solicitud/4/")
    return axios.put(`${API_URL}/formulario-visita/${id_formulario}/`, params, headers);
};

export async function updateForm (values) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    //FOTO
    if(values.photo){
        const file = await getFromFile(values.photo)
        const file2 = await resizedataURL(file)
        const params_foto = {
            "EMAIL": values.user.email,
            "FOTO": file2,
        };
        await axios.post(`${API_URL}/ingresar_imagen/`, params_foto, headers);
    }
    //AGREGAR ESTADO CIVIL
    const params = {
        "NOMBRES": values.nombres,
        "PATERNO": values.paterno,
        "MATERNO": values.materno,
        "RUT_PASAPORTE": values.rut_pasaporte,
        "ID_PAIS": values.address.country,
        "ID_CIUDAD": values.address.city,
        "DIRECCION": values.address.street,
        "TELEFONO": values.phone,
        "GENERO": values.gender,
        "FECHA_NACIMIENTO": values.birthday.format('YYYY-MM-DD'),
        "EMAIL": values.user.email,
        "ID_ESTADO_CIVIL": values.estado_civil,
    };
    return axios.put(`${API_URL}/formulario-visita/${values.idFormulario}/`, params, headers);

};

//nombres, paterno, materno, rut, ciudad, direccion, telefono, genero, nacimiento, email
//Funcion para mandar  mails con invitaciones a rellenar formularios remotos
export async function crearSolUni(values){
    console.log(values)
    let idPersona = await getIdFuncionario(window.User.Rut)
    var res2 =  await createSol(
    idPersona.data.id_persona,
    window.ENV.API_URL+"/tipos-visita/" + values.visittype + "/", // tipo, "N"
    values.id_sponsor,
    values.inicio_visita,
    values.termino_visita,
    values.unidad,
    0
    )
    console.log("res2:",res2)
    return res2;
}

export async function Invites(values){
    
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    
    const params = {
        "correos": values.correos,
        "tipo_visita": values.tipo_visita,
        "id_sponsor": values.id_sponsor,
        "inicio_visita": values.inicio_visita,
        "termino_visita": values.termino_visita,
        "departamento": values.departamento,
        "organismo": values.organismo,
        "depart": values.depart
    };
    
    const res = await axios.post(`${API_URL}/crear_invitacion/`, params, headers);
    return res;
};

//Función para  subir el formulario de una prorroga
export async function FormularioProrroga(values,id_visita){
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    const params = {
        "fechas": values.dates[1].format('YYYY-MM-DD'),
        "causal": values.causal,
        "id_visita": id_visita
    };
    
    const res = await axios.post(`${API_URL}/crear_prorroga/`, params, headers);
    return res;
}

//Función para actualizas solicitudes 
export const actualizarSolicitud = (values) => {
    return updateSol(values.data.id_solicitud,
        values.comentario,
        1,
        values.data.id_tipo_visita.url,
        values.estado,
        values.data.id_visita.url,
        values.data.id_patrocinador.url,
        values.data.fecha_inicio,
        values.data.fecha_termino,
        values.data.id_facultad,
        values.data.id_unidad);
}

export function getIdFuncionario(rut) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    const params = {
        "rut": rut,
    };
    console.log("params",params)
    return axios.post(`${API_URL}/id_funcionario/`, params, headers);
}

//Funcion para formVisit
export async function crearFormularioPresencial(data) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };

    if(data.photo){
        const file = await getFromFile(data.photo)
        const file2 = await resizedataURL(file)
        data.photo = await file2
    }
    const params = {
        'data': data
    }
    return await axios.post(`${API_URL}/crear_formulario_presencial/`, params,headers);
}

//Funcion para formularioRemoto
export async function crearFormularioRemoto (data) {
    const headers = {
        headers: {
            Authorization: window.Token
        }
    };
    if(data.photo){
        const file = await getFromFile(data.photo)
        const file2 = await resizedataURL(file)
        data.photo = await file2
    }
    const params = {
        'data': data
    };
    return await axios.post(`${API_URL}/crear_formulario_remoto/`, params,headers);
};

export async function getVisitEnlace(enlace){
    let params= {
        data: enlace
    }

    return axios.post(`${API_URL}/datos_enlace/`, params);

}